import { InfoIcon } from "@phosphor-icons/react";

import { classNames, Text } from "@alpacahq/ui/old";

import { Path } from "../../path";

export interface DisclosureProps {
  className?: string;
}

export const Disclosure = ({ className }: DisclosureProps) => {
  const year = new Date().getFullYear();

  return (
    <footer
      className={classNames(
        "mx-auto my-0 flex w-full flex-col gap-4 text-xs leading-5 transition-all ease-in-out md:max-w-5xl",
        className,
      )}
    >
      <div className="flex flex-col gap-2 text-zinc-400">
        <div>
          <Text>&copy; {year} AlpacaDB, Inc. All rights reserved.</Text>
          <Text>&copy; {year} Alpaca Securities LLC All rights reserved.</Text>
          <Text>&copy; {year} Alpaca Crypto LLC All rights reserved.</Text>
        </div>
        <Text>
          Securities Brokerage services are provided by Alpaca Securities ,
          member FINRA/SIPC, a wholly-owned subsidiary of AlpacaDB, Inc.
          Technology and services are offered by AlpacaDB, Inc.
        </Text>
        <Text>
          Cryptocurrency services are made available by Alpaca Crypto LLC
          ("Alpaca Crypto"), a FinCEN registered money services business (NMLS #
          2160858), and a wholly-owned subsidiary of AlpacaDB, Inc. Alpaca
          Crypto is not a member of SIPC or FINRA. Cryptocurrencies are not
          stocks and your cryptocurrency investments are not protected by either
          FDIC or SIPC. Please see the Disclosure Library for more information.
        </Text>
        <Text>
          This is not an offer, solicitation of an offer, or advice to buy or
          sell securities or cryptocurrencies, or open a brokerage account or
          cryptocurrency account in any jurisdiction where Alpaca Securities,
          Alpaca Crypto, are not registered or licensed, as applicable.
        </Text>
      </div>
      <div className="flex items-center gap-2 text-zinc-500">
        <InfoIcon size={16} />
        <div
          className="cursor-pointer underline"
          onClick={() => window.open(Path.URL_DISCLOSURES, "_blank")}
          style={{
            fontWeight: 450,
          }}
        >
          View important disclosures
        </div>
      </div>
    </footer>
  );
};
